/**
 * {RelivConferenceSelectedConference}
 * @param window

 * @constructor
 */
var RelivConferenceSelectedConference = function (
    window
) {
    var self = this;

    self.selected = 0;

    self.setSelected = function (conferenceId) {

        self.display = conferenceId;

        window.localStorage.setItem('relivConferenceSelectedConferenceId', String(conferenceId));
    };

    self.getSelected = function () {
        var conferenceId = window.localStorage.getItem('relivConferenceSelectedConferenceId');
        return Number(conferenceId);
    };

    var setSelectedByUrl = function () {
        if (!window.URL) {
            return;
        }

        let params = (new window.URL(window.location)).searchParams;

        var conferenceId = params.get('selectedConferenceId');

        if (conferenceId) {
            self.setSelected(conferenceId);
        }
    };

    var init = function () {
        setSelectedByUrl();
        self.selected = self.getSelected();
    };

    init();
};

/**
 * @returns {relivConferenceSelectedConference}
 */
angular.module('relivConference').service(
    'relivConferenceSelectedConference',
    [
        '$window',
        function (
            $window
        ) {
            return new RelivConferenceSelectedConference(
                $window
            );
        },
    ]
);
